import React from "react";
import { Box, Grid, Stack, Typography, styled } from "@mui/material";
import { Title, Text } from "./style";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AccIcon from "../../images/landing/account_box.png";
import EncrIcon from "../../images/landing/encrypted.png";
import BarsIcon from "../../images/landing/bar_chart_4_bars.png";
import AirlineIcon from "../../images/landing/airline_stops.png";
import InventoryIcon from "../../images/landing/inventory_2.png";
import RightIcon from "../../images/landing/mobile right.png";
import LeftIcon from "../../images/landing/mobile left.png";
import MobilesIcon from "../../images/landing/mobiles.png";

const RootStyle = styled(Box)(({ theme }) => ({
  background: "#ffffff",
  padding: "72px 83px",
  [theme.breakpoints.down("md")]: {
    padding: "30px 15px",
  },
}));
const GridBox = styled(Grid)({});

const IconBox = styled(Box)({
  height: "56px",
  width: "56px",
  background: "#FBF8DB",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "8px",
});
const ItemBox = styled(Box)((props) => ({
  height: "50px",
  padding: "0 16px",
  display: "flex",
  alignItems: "center",
  columnGap: "16px",
  background: props.sel ? "#FBF8DB" : "#FFFFFF",
  cursor: "pointer",
  borderRadius: "8px",
  marginBottom: "8px",
}));
const SubTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "24px",
  color: "#60656C",
  [theme.breakpoints.down("md")]: {
    fontSize: "19px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "16spx",
  },
}));

function BenefitsSection() {
  return (
    <RootStyle>
      <Title sx={{ mb: { xs: "30px", md: "73px" }, textAlign: "center" }}>
        Benefits of ManageKaro
      </Title>
      <Grid container spacing={5}>
        <GridBox
          item
          md={4}
          xs={12}
          sx={{
            display: { xs: "flex", md: "none" },
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              maxHeight: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img width="80%" src={MobilesIcon} alt="" />
          </Box>
        </GridBox>
        <GridBox item md={4} xs={12}>
          <Box sx={{ mb: 1.6 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <SubTitle>Free trial to test ManageKaro</SubTitle>
              <IconBox>
                <LocalOfferOutlinedIcon
                  sx={{ fontSize: "30px", color: "#4eaf51" }}
                />
              </IconBox>
            </Box>

            <Text sx={{ mt: 1, width: "80%" }}>
              With the basic free trial, you can seamlessly create custom
              invoices/bills. You can also manage your dashboard and track
              inventory items. The free access provides you many other useful
              features with options to upgrade any time.
            </Text>
          </Box>
          <Box sx={{ mb: 1.6 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <SubTitle>Keep your data secure</SubTitle>
              <IconBox>
                <img height="25px" src={EncrIcon} alt="" />
              </IconBox>
            </Box>

            <Text sx={{ mt: 1, width: "80%" }}>
              Using ManageKaro in Pakistan, you get an automatic data backup,
              allowing you to safeguard the data stored in the app. Advanced
              encryption and cloud backup allows secure data at all times.
            </Text>
          </Box>
          <Box sx={{ mb: 1.6 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <SubTitle>Build positive brand image</SubTitle>
              <IconBox>
                <img height="25px" src={AccIcon} alt="" />
              </IconBox>
            </Box>

            <Text sx={{ mt: 1, width: "80%" }}>
              Providing professional quotes, invoices and bills during
              negotiation builds a positive brand image. Furthermore, you can
              stay on top of all the ledger entries with automated updates.
            </Text>
          </Box>
        </GridBox>
        <GridBox
          item
          md={4}
          xs={12}
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              maxHeight: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <img style={{ maxHeight: "355px" }} src={RightIcon} alt="" />
          </Box>
          <Box
            sx={{
              maxHeight: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <img style={{ maxHeight: "355px" }} src={LeftIcon} alt="" />
          </Box>
        </GridBox>
        <Grid item md={4} xs={12}>
          <Box sx={{ mb: 1.6, display: "flex" }}>
            <IconBox sx={{ width: "56px" }}>
              <img src={BarsIcon} alt="" />
            </IconBox>
            <Box sx={{ width: "80%", ml: 2 }}>
              <SubTitle>Track your business status</SubTitle>
              <Text sx={{ mt: 1 }}>
                ManageKaro business dashboard makes the entire business
                management process seamless. You can track business cash flow,
                inventory status, price changes, and ledger updates in one
                place.
              </Text>
            </Box>
          </Box>
          <Box sx={{ mb: 1.6, display: "flex" }}>
            <IconBox>
              <img src={AirlineIcon} alt="" />
            </IconBox>
            <Box sx={{ width: "80%", ml: 2 }}>
              <SubTitle>Manage cashflow easily</SubTitle>
              <Text sx={{ mt: 1 }}>
                ManageKaro enables businesses to record transactions with ledger
                and cash entries so payments can be easily tracked and traced
                back to the source transaction. Many businesses rely on our
                cashflow management features for their billing, reporting,
                profit calculations and much more.
              </Text>
            </Box>
          </Box>
          <Box sx={{ mb: 1.6, display: "flex" }}>
            <IconBox>
              <img src={InventoryIcon} alt="" />
            </IconBox>
            <Box sx={{ width: "80%", ml: 2 }}>
              <SubTitle>Manage your inventory</SubTitle>
              <Text sx={{ mt: 1, width: "80%" }}>
                Using ManageKaro, you can keep track of available items, out of
                stock items and expired items in one place. You can set up low
                inventory alerts to place advance orders and detect possible
                theft.
              </Text>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </RootStyle>
  );
}

export default BenefitsSection;
